import {VueEventBubble} from "./vue-bubble";
import {VueStoreProviders} from  "./vue-store-providers";
import {VueLang} from "./vue-lang";
import {VueIsMobile} from "./vue-is-mobile";
import {VueSuper} from "./vue-super";

import VueI18n from "vue-i18n";

export function registerPlugins(Vue){
  Vue.use(VueI18n);
  Vue.use(VueEventBubble);
  Vue.use(VueStoreProviders);
  Vue.use(VueLang);
  Vue.use(VueIsMobile);
  Vue.use(VueSuper);
}